
import { Component, Prop, Vue } from 'vue-property-decorator';
import VTable from '@/components/shared/table/VTable.vue';
import EnrollmentsFilter from '@/components/enrollments/EnrollmentsFilter.vue';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import { Venue } from '@/interfaces/models/Venue';
import { Enrollment } from '@/interfaces/models/Enrollment';
import { Permission } from '@/enums/Permission';
import { EnrollmentStatus } from '@/enums/EnrollmentStatus';
import { RolloutStatus } from '@/enums/RolloutStatus';
import headers from './headers';

@Component({
  components: { VTable, EnrollmentsFilter },
})
export default class EnrollmentsTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: Enrollment[];
  @Prop({ type: Number, required: true }) public total!: number;
  @Prop({ type: Array, required: true }) public venues!: Venue[];

  public headers: ColumnHeader[] = headers;

  public canAccept(status: EnrollmentStatus): boolean {
    return this.$can(Permission.OAUTH_ENROLLMENT_ACCEPT) && status === EnrollmentStatus.PENDING;
  }

  public canReject(status: EnrollmentStatus): boolean {
    return this.$can(Permission.OAUTH_ENROLLMENT_REJECT) && status === EnrollmentStatus.PENDING;
  }

  public enrollmentStatusColor(status: EnrollmentStatus): string {
    return status === EnrollmentStatus.PENDING
      ? 'grey lighten-3'
      : status === EnrollmentStatus.REJECTED
      ? 'red lighten-3'
      : 'green lighten-3';
  }

  public rolloutStatusColor(status: RolloutStatus): string {
    return status === RolloutStatus.PENDING
      ? 'grey lighten-3'
      : status === RolloutStatus.IN_PROGRESS
      ? 'yellow lighten-3'
      : status === RolloutStatus.FAILED
      ? 'red lighten-3'
      : 'green lighten-3';
  }

  public getVenueName(venueId: string): string {
    if (!venueId) {
      return '';
    }

    const venue = this.venues.find((v: Venue) => v._id === venueId);

    return venue ? venue.name : venueId;
  }

  public accept(id: string) {
    this.$emit('accept', id);
  }

  public reject(id: string) {
    this.$emit('reject', id);
  }
}
